import { Metric } from '../../../../dashboard-config/dashboard-config.model';
import {
  expandProductCatalog,
  ProductCatalogEntry,
} from '../../../_shared/dashboard-definition.model';
import {
  ComparisonMetricProfile,
  comparisonCompaniesCountProfile,
  comparisonCompaniesRevenueProfile,
  comparisonEconomicParticipantProfile,
  comparisonEmployedProfile,
  comparisonGvaProfile,
} from '../comparison-metric.profile';
import { createDashboardComparisonFourGridDefinition } from './create-dashboard-comparison-four-grid-definition';
import { DashboardComparisonFourGridShell } from './dashboard-comparison-four-grid-shell.profile';
import { DashboardComparisonFourGridDefinition } from './dashboard-comparison-four-grid.definition';

/**
 * Product catalog for national comparison four-grid dashboards.
 * Identity is derived in {@link createDashboardComparisonFourGridDefinition}.
 */

// No districts: comparison at Kreise is the comparison-structure view.
type ComparisonFourGridMetric = Exclude<
  Metric,
  Metric.Tourism | Metric.SelfEmployed
>;

export const COMPARISON_FOUR_GRID_PRODUCT_CATALOG: Record<
  ComparisonFourGridMetric,
  ProductCatalogEntry<ComparisonMetricProfile, DashboardComparisonFourGridShell>
> = {
  [Metric.CompaniesCount]: {
    metric: comparisonCompaniesCountProfile,
    shells: ['states', 'wzClassStates', 'subMarkets', 'districtSubMarkets', 'wzClasses', 'districtWzClasses'],
  },
  [Metric.CompaniesRevenue]: {
    metric: comparisonCompaniesRevenueProfile,
    shells: ['states', 'wzClassStates', 'subMarkets', 'districtSubMarkets', 'wzClasses', 'districtWzClasses'],
  },
  [Metric.GrossValueAdded]: {
    metric: comparisonGvaProfile,
    shells: ['states', 'wzClassStates', 'subMarkets', 'districtSubMarkets', 'wzClasses', 'districtWzClasses'],
  },
  // No districtWzClasses from here on: Kreise × WZ-Klassen is bottom-up only, for Count, Revenue and GVA.
  [Metric.EconomicParticipant]: {
    metric: comparisonEconomicParticipantProfile,
    shells: ['states', 'wzClassStates', 'subMarkets', 'districtSubMarkets', 'wzClasses'],
  },
  [Metric.Employed]: {
    metric: comparisonEmployedProfile,
    shells: ['states', 'wzClassStates', 'subMarkets', 'districtSubMarkets', 'wzClasses'],
  },
};

/** All national comparison four-grid product definitions. */
export const COMPARISON_FOUR_GRID_DEFINITIONS: DashboardComparisonFourGridDefinition[] =
  expandProductCatalog(
    Object.values(COMPARISON_FOUR_GRID_PRODUCT_CATALOG),
    createDashboardComparisonFourGridDefinition,
  );
